import { mxPoint } from './graph/mxModule';

export function moveConnectedEdges(graph, selectedCells, dx, dy) {
  const model = graph.getModel();
  const movedEdges = new Set();
  const movedCells = new Set();

  const addMovedCell = (cell) => {
    movedCells.add(cell);

    const childCount = model.getChildCount(cell);
    for (let i = 0; i < childCount; i += 1) {
      addMovedCell(model.getChildAt(cell, i));
    }
  };

  selectedCells.forEach(addMovedCell);

  const moveEdgesForCell = (cell) => {
    const edges = model.getEdges(cell);

    edges?.forEach((edge) => {
      // Don't move the edge if it's also selected
      if (!selectedCells.includes(edge) && !movedEdges.has(edge)) {
        movedEdges.add(edge);

        const geo = edge.getGeometry();
        if (geo) {
          const newGeo = geo.clone();
          let geometryChanged = false;

          // Handle waypoints (your existing logic)
          if (geo.points && geo.points.length > 0) {
            newGeo.points = newGeo.points.map(
              (pt) => new mxPoint(pt.x + dx, pt.y + dy)
            );
            geometryChanged = true;
          }

          // Get terminal connections
          const sourceTerminal = model.getTerminal(edge, true);
          const targetTerminal = model.getTerminal(edge, false);

          // Handle floating source point (unconnected start)
          if (!sourceTerminal && geo.sourcePoint) {
            newGeo.sourcePoint = new mxPoint(
              geo.sourcePoint.x + dx,
              geo.sourcePoint.y + dy
            );
            geometryChanged = true;
          }
          // If source is connected to the moved cell, ensure no floating point
          else if (movedCells.has(sourceTerminal) && geo.sourcePoint) {
            newGeo.sourcePoint = null;
            geometryChanged = true;
          }

          // Handle floating target point (unconnected end)
          if (!targetTerminal && geo.targetPoint) {
            newGeo.targetPoint = new mxPoint(
              geo.targetPoint.x + dx,
              geo.targetPoint.y + dy
            );
            geometryChanged = true;
          }
          // If target is connected to the moved cell, ensure no floating point
          else if (movedCells.has(targetTerminal) && geo.targetPoint) {
            newGeo.targetPoint = null;
            geometryChanged = true;
          }

          // Only update geometry if something changed
          if (geometryChanged) {
            model.setGeometry(edge, newGeo);
          }
        }
      }
    });

    const childCount = model.getChildCount(cell);
    for (let i = 0; i < childCount; i += 1) {
      moveEdgesForCell(model.getChildAt(cell, i));
    }
  };

  selectedCells.forEach((cell) => {
    moveEdgesForCell(cell);
  });
}